var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReceipt = function SvgReceipt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1385 26.8418C9.9231 26.8839 9.70413 26.9052 9.48462 26.9055H10.1385V26.8418Z",
    fill: "#575757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1403 26.8982H22.9178C22.2583 26.8755 21.634 26.5947 21.1795 26.1163C20.7249 25.6378 20.4763 25 20.4873 24.3401V19.1662C20.4873 19.1049 20.4752 19.0442 20.4516 18.9876C20.4279 18.9311 20.3933 18.8798 20.3497 18.8367C20.3061 18.7936 20.2544 18.7597 20.1975 18.7367C20.1407 18.7138 20.0799 18.7024 20.0186 18.7032H6.47722C6.4167 18.7032 6.35677 18.7152 6.30092 18.7385C6.24508 18.7618 6.19442 18.796 6.15189 18.8391C6.10937 18.8822 6.07581 18.9333 6.05318 18.9894C6.03055 19.0456 6.01929 19.1056 6.02006 19.1662V23.4257C6.02006 24.3467 6.38587 25.2299 7.03702 25.8811C7.68818 26.5323 8.57133 26.8982 9.4922 26.8982H10.1403Z",
    stroke: "#575757",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1401 18.7035V14.8086",
    stroke: "#575757",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1401 4.79081V2.99671C10.14 2.8481 10.1969 2.70512 10.2993 2.59738C10.4016 2.48964 10.5415 2.4254 10.6899 2.41797H25.8516C26.0051 2.41797 26.1523 2.47894 26.2608 2.58748C26.3693 2.69601 26.4303 2.84322 26.4303 2.99671V23.4263C26.4303 24.3473 26.0645 25.2305 25.4133 25.8817C24.7622 26.5329 23.879 26.8988 22.9582 26.8988V26.8988C22.2986 26.8761 21.6743 26.5953 21.2198 26.1169C20.7652 25.6385 20.5166 25.0006 20.5276 24.3407",
    stroke: "#575757",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98715 5.50905C8.83665 5.50791 9.66739 5.75879 10.3743 6.22995C11.0812 6.70112 11.6324 7.37139 11.9583 8.15596C12.2842 8.94054 12.3701 9.80415 12.205 10.6375C12.04 11.4709 11.6315 12.2366 11.0312 12.8378C10.4309 13.4389 9.66585 13.8485 8.83276 14.0147C7.99967 14.1808 7.13602 14.0961 6.35108 13.7713C5.56613 13.4464 4.89518 12.896 4.4231 12.1897C3.95103 11.4834 3.69905 10.6529 3.69905 9.80332C3.69365 9.23838 3.80083 8.67802 4.01435 8.15495C4.22786 7.63189 4.54342 7.1566 4.94261 6.75684C5.3418 6.35707 5.81662 6.04084 6.33935 5.8266C6.86208 5.61237 7.42225 5.50442 7.98715 5.50905ZM7.98715 4.35157C6.63698 4.35345 5.33554 4.85637 4.3349 5.76292C3.33426 6.66947 2.70562 7.91515 2.57074 9.25869C2.43586 10.6022 2.80433 11.948 3.60479 13.0354C4.40524 14.1228 5.58073 14.8745 6.90358 15.1447C8.22643 15.415 9.60251 15.1847 10.7653 14.4985C11.9281 13.8122 12.7948 12.7188 13.1977 11.43C13.6006 10.1412 13.5108 8.74874 12.9459 7.52232C12.381 6.29589 11.3811 5.32277 10.1399 4.79141C9.45959 4.50019 8.72714 4.35054 7.98715 4.35157Z",
    fill: "#575757"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64941 10.2195L6.98619 11.6779L10.331 7.92188",
    stroke: "#575757",
    strokeWidth: 0.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReceipt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/receipt.50d54349.svg";
export { ForwardRef as ReactComponent };